export default "__VITE_ASSET__uNgCp6NS__"